<template>
  <v-row no-gutters class="pt-10 pb-5" justify="center">
    <v-col cols="12" lg="10" xl="8">
      <v-row no-gutters align="center" class="pb-4">
        <v-col>
          <h3>Lista Utenti</h3>
        </v-col>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                fab
                depressed
                dark
                small
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>Aggiungi</span>
        </v-tooltip>
      </v-row>
      <v-row no-gutters class="white bra align-start pa-3">
        <v-data-table
            :headers="headers"
            :items="items"
            item-key="name"
            class="pa-3 pt-0 pb-0"
            no-data-text="Nessun dato disponibile"
            :loading="loading"
            loading-text="Caricamento in corso..."
        >
          <template v-slot:item.actions="{ item }">
            <v-btn
                fab
                depressed
                dark
                small
                color="primary"
                target="_blank"
                icon
                @click="edit(item)"
                :href="item.report"
            >
              <v-icon small dark>
                mdi-clipboard-edit-outline
              </v-icon>
            </v-btn>
            <action-confirm @method="reset(item.email)" icon="mdi-lock-alert" text="L'utente selezionato riceverà una e-mail con un link per procedere al reset della password."></action-confirm>
            <action-confirm @method="del(item.id)" icon="mdi-delete" text="Stai per eliminare definitivamente l'utente selezionato. Confermando non potrà essere più recuperato."></action-confirm>
          </template>
        </v-data-table>
      </v-row>
    </v-col>
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="grey lighten-2 pt-2">
          Aggiungi Utente
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row no-gutters>
            <v-col cols="6" class="pa-3 pt-0">
              <span class="label">Nome</span>
              <input class="input" v-model="user.first_name">
            </v-col>
            <v-col cols="6" class="pa-3 pt-0">
              <span class="label">Cognome</span>
              <input class="input" v-model="user.last_name">
            </v-col>
            <v-col cols="6" class="pa-3 pt-0">
              <span class="label">Email</span>
              <input class="input" v-model="user.email">
            </v-col>
            <v-col cols="6" class="pa-3 pt-0">
              <span class="label">Password</span>
              <input class="input" :disabled="user.edit" type="password" v-model="user.password">
            </v-col>
            <v-col cols="12" class="pa-3 pt-0">
              <v-select v-model="user.role" placeholder="Seleziona ruolo" :items="roles">
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
              color="error"
              text
              @click="dialog = false"
          >
            Annulla
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" v-if="user.edit" text @click="update">
            <span v-if="!loading">Aggiorna</span>
            <v-progress-circular
                v-else
                indeterminate
                color="primary"
                :size="20"
                :width="2"
            ></v-progress-circular>
          </v-btn>
          <v-btn color="primary" v-else text @click="store">
            <span v-if="!loading">Conferma</span>
            <v-progress-circular
                v-else
                indeterminate
                color="primary"
                :size="20"
                :width="2"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    import { db } from "@/main";
    import firebase from 'firebase';
    import ActionConfirm from '@/components/actions/confirm'
    // @ is an alias to /src
    export default {
        name: 'home',
        components: {ActionConfirm},
        methods: {
          edit(item) {
            this.user = item
            this.user.edit = true
            this.dialog = true
          },
          get() {
            db.collection("users").orderBy('updated_at', "desc").get().then((data) => {
              data.forEach(elm => {
                let item = elm.data()
                item.id = elm.id
                this.items.push(item)
              })
            })
          },
          store() {
            this.loading = true
            firebase.auth().createUserWithEmailAndPassword(this.user.email, this.user.password).then((res) => {
              db.collection('users').doc(res.user.uid).set({
                "created_at": firebase.firestore.Timestamp.fromDate(new Date()),
                "updated_at": firebase.firestore.Timestamp.fromDate(new Date()),
                "first_name": this.user.first_name,
                "last_name": this.user.last_name,
                "email": this.user.email,
                "role": this.user.role
              }).then(() => {
                this.items.unshift({
                  "id": res.user.uid,
                  "first_name": this.user.first_name,
                  "last_name": this.user.last_name,
                  "email": this.user.email,
                  "role": this.user.role
                })
                this.clean()
              })
            })
          },
          update() {
            this.loading = true
              db.collection('users').doc(this.user.id).update({
                "updated_at": firebase.firestore.Timestamp.fromDate(new Date()),
                "first_name": this.user.first_name,
                "last_name": this.user.last_name,
                "email": this.user.email,
                "role": this.user.role,
              }).then(() => {
                this.items = []
                db.collection("users").orderBy('updated_at', "desc").get().then((data) => {
                  data.forEach(elm => {
                    let item = elm.data()
                    item.id = elm.id
                    this.items.push(item)
                  })
                  this.loading = false
                })
                this.clean()
              })
          },
          reset(email) {
            firebase.auth().sendPasswordResetEmail(email).then((res) => {
              console.log(res)
            })
          },
          del(id) {
            db.collection("users").doc(id).delete().then(() => {
              this.items.splice(this.items.findIndex(x => x.id === id), 1);
            })
          },
          clean() {
            this.dialog = false
            this.loading = false
            this.user = {
              email: null,
              first_name: null,
              last_name: null,
              password: null,
              edit: false
            }
          }
        },
        mounted () {
          // Binding Collections
          db.collection("users").orderBy('updated_at', "desc").get().then((data) => {
           data.forEach(elm => {
             let item = elm.data()
             item.id = elm.id
             this.items.push(item)
           })
           this.loading = false
          })
        },
        data: () => ({
          dialog: false,
          headers: [
            { text: 'Azioni', value: 'actions', sortable: false, align: 'center' },
            { text: 'Nome', align: 'start', sortable: false, value: 'first_name'},
            { text: 'Cognome', align: 'start', sortable: false, value: 'last_name'},
            { text: 'Role', align: 'start', sortable: false, value: 'role'},
            { text: 'Email', value: 'email', },
          ],
          items: [],
          roles: [
              "user",
              "admin",
              "company",
              "expert"
          ],
          loading: true,
          user: {
            email: null,
            first_name: null,
            last_name: null,
            password: null,
            edit: false
          }
        }),
    }
</script>
